import styles from './AuthFailScreen.module.scss';

export function AuthFailScreen() {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrap}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
            stroke="#e53535"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <p className={styles.title}>Authentication Failed</p>
      <p className={styles.message}>
        We couldn't verify your credentials. Please check your configuration and
        try again.
      </p>
    </div>
  );
}
